/*
 *	This module provides the access to the global EQ.js
 *
 *	Copyright (C) 2022-2024, EQIT. All rights reserved.
 *	Created by David Hsieh <david@eqit.com.tw>
 */
/**
 * nuDialog
 */
export var E_nuDialog_headerState;
(function (E_nuDialog_headerState) {
    E_nuDialog_headerState[E_nuDialog_headerState["NONE"] = 0] = "NONE";
    E_nuDialog_headerState["INFO"] = "info";
    E_nuDialog_headerState["WARN"] = "warning";
    E_nuDialog_headerState["ERROR"] = "error";
})(E_nuDialog_headerState || (E_nuDialog_headerState = {}));
;
////////////////////////////////////////////////////////////
//
//	Exporting functions
//
////////////////////////////////////////////////////////////
// eqlogging
export function setLoggerLevel(level, name) {
    return EQ.logging.setLoggerLevel(level, name, true);
}
export function getLogger(name) {
    return EQ.logging.getLogger(name);
}
export function resetLogger() {
    return EQ.logging.resetLogger();
}
// myDateTime
export function getMyDateTime(d) {
    return EQ.utils.getMyDateTime(d);
}
/**
 * Set the index page for this portal.
 * It will be presented by bootstrap.js after HTML document loaded.
 * @param page an instance implements I_IndexPage.
 */
export function setIndexPage(page) {
    EQ.page = page;
}
/**
 * Application Loader.
 * Load and construct an uiPageStackApp which implemented with EQ.Class.
 * @param jsfile the implementation module
 * @param jsname the class name of EQ.Class
 * @param ctx the context for construction
 * @param options the options for construction
 * @returns a promise that resolve an uiPageStackApp.
 */
export function loadUiPageStackApp(jsfile, jsname, ctx, options) {
    return EQ.utils.loadUiPageStackApp(jsfile, jsname, ctx, options);
}
// Append Styles
export function appendCSS(id, css) {
    return EQ.AppendCSS(id, css);
}
// Common Utilities
export function getSessionId() { return EQ.sessionId; }
export function getParameters() { return EQ.params; }
export function getLangauge() { return EQ.language; }
export function getSupportedLanguage() { return EQ.supportedLanguage; }
export function getHttpHost() { return EQ.httpHost; }
export function getSEQ() { return EQ.utils.getSEQ(); }
export function getMaxZ() { return EQ.utils.maxZ(); }
export function md5sum(s) { return EQ.utils.md5(s); }
export function setupDefault(e) { EQ.utils.setupDefault(e); }
export function resetToDefault(e) { EQ.utils.resetToDefault(e); }
export function isDirty(e) { return EQ.utils.isDirty(e); }
export function getBrowserInfo() { return EQ.utils.getBrowserInfo(); }
export function getClientHint() { return EQ.utils.getClientHint(); }
export function htmlSpecialChars(s) { return EQ.utils.htmlspecialchars(s); }
export function getUsername() {
    // With sessControl, the callback function will be assigned
    // since the session control is controlling the session
    // authentication.
    if (EQ.api.getUsername) {
        console.warn('DEPRECATED: use sessControl.Instance.username to get the username.');
        return EQ.api.getUsername();
    }
    // For the old implementation, the authentication status
    // is recorded at EQ.authentication.
    if (!EQ.authentication)
        return null;
    if (!EQ.authentication.username)
        return null;
    return EQ.authentication.username;
}
export function getRole() {
    // With sessControl, the callback function will be assigned
    // since the session control is controlling the session
    // authentication.
    if (EQ.api.getRole) {
        console.warn('DEPRECATED: use sessControl.Instance.role to get the role name.');
        return EQ.api.getRole();
    }
    // For the old implementation, the authentication status
    // is recorded at EQ.authentication.
    if (!EQ.authentication)
        return null;
    if (!EQ.authentication.role)
        return null;
    return EQ.authentication.role;
}
// Convert number to string
export function BtoString(v, f) { return EQ.utils.BtoString(v, f); }
export function KBtoString(v, f) { return EQ.utils.KBtoString(v, f); }
export function BPStoString(v, f) { return EQ.utils.BPStoString(v, f); }
export function KBPStoString(v, f) { return EQ.utils.KBPStoString(v, f); }
export function NtoString(v, f) { return EQ.utils.NtoString(v, f); }
export function KNtoString(v, f) { return EQ.utils.KNtoString(v, f); }
export function MStoString(v, f) { return EQ.utils.MStoString(v, f); }
export function UStoString(v, f) { return EQ.utils.UStoString(v, f); }
export function SECtoString(v) { return EQ.utils.SECtoString(v); }
export function ProtToString(v) { return EQ.utils.ProtToString(v); }
export function PortToString(v) { return EQ.utils.PortToString(v); }
// Select2
export function select2(ctx, opt) { EQ.utils.select2(ctx, opt); }
// d3.schemeDark2
export function d3SchemeDark2() { return EQ.utils.d3SchemeDark2(); }
// d3.schemePastel2
export function d3SchemePastel2() { return EQ.utils.d3SchemePastel2(); }
// Common UI components from bootstrap.js
export function submitLogout() { EQ.api.submitLogout(); }
export function getMainApplicationMenu() { return EQ.api.getMainApplicationMenu(); }
export function waitMask(msg, withProgress) {
    EQ.api.waitMask(msg, withProgress);
}
export function waitProgress(percent) { EQ.api.waitProgress(percent); }
export function waitUnmask(cbfn) { EQ.api.waitUnmask(cbfn); }
export function userSettings() { EQ.api.userSettings(); }
export function nuNotice(d) { return EQ.api.nuNotice(d); }
export function nuError(d) { return EQ.api.nuError(d); }
export function nuWarning(d) { return EQ.api.nuWarning(d); }
export function nuYesno(d) { return EQ.api.nuYesno(d); }
export function nuYesnocancel(d) { return EQ.api.nuYesnocancel(d); }
export function nuNoperm(d) { return EQ.api.nuNoperm(d); }
export function registerNudlg(cbfn) {
    EQ.api.nuNotice = cbfn.notice;
    EQ.api.nuError = cbfn.error;
    EQ.api.nuWarning = cbfn.warning;
    EQ.api.nuYesno = cbfn.yesno;
    EQ.api.nuYesnocancel = cbfn.yesnocancel;
    EQ.api.nuNoperm = cbfn.noperm;
    EQ.api.waitMask = cbfn.waitmask;
    EQ.api.waitProgress = cbfn.waitprogress;
    EQ.api.waitUnmask = cbfn.waitunmask;
}
// Settings application
export function registerSettingsActivator(cbfn) {
    EQ.api.activateSettings = cbfn;
}
/**
 * Active the settings Page.
 * If type is T_uiPage, the left menu is unselected and active this page.
 * If type is string, the left menu is selected and active this page on setting menu.
 * @param page T_uiPage | string (name on menu)
 */
export function activateSettings(page) {
    if (EQ.api.activateSettings)
        EQ.api.activateSettings(page);
}
/**
 * Launch the appjs implemented system settings page from the ESM.
 * This is used when EQUI is built in eq.bundle.js for EQWSE webguii
 * where the system setting is implemented in appjs.
 */
export function launchAppjsSystemSettings() {
    if (EQ.api.launchAppjsSystemSettings)
        EQ.api.launchAppjsSystemSettings();
}
// bootstrap modal
export function replaceBsModal(bsModal) {
    EQ.utils.bsModal = bsModal;
}
export function bsModal(ctx, opt) {
    return EQ.utils.bsModal(ctx, opt);
}
////////////////////////////////////////////////////////////
//
//	Session Timeout handler
//
////////////////////////////////////////////////////////////
/**
 * Call the registered Session Timeout Handler.
 */
export function handleSessionTimeout() {
    if (typeof EQ.api.handleSessionTimeout === 'function')
        EQ.api.handleSessionTimeout();
}
/**
 * Register a Session Timeout Handler
 * @param cbfn the handler
 */
export function registerSessionTimeoutHandler(cbfn) {
    EQ.api.handleSessionTimeout = cbfn;
}
/**
 * Register the functions of query user info.
 * @param cbfnUser the callback function to query the user name
 * @param cbfnRole the callback function to query the user's role
 */
export function registerUserInfoGetter(cbfnUser, cbfnRole) {
    EQ.api.getUsername = cbfnUser;
    EQ.api.getRole = cbfnRole;
}
